import styled from 'astroturf/react'
import { useDeviceType } from '@calendly/ui/hooks/use-device-type'
import { parseQuery } from '@calendly/http-tools'
import { useSelector, useDispatch } from 'react-redux'
import { Calendar, DatesTitle as Title, CalendarContainer, DatesWrapper as Wrapper } from '@calendly/booking-kit'
import { useCallback } from 'react'

import { selectCalendarDay } from 'actions/calendar_day'
import { removeSpotFromCheckQueue } from 'actions/spot'
import { changeCalendarMonth } from 'actions/calendar'
import { eventTypeSelector } from 'root-api'
import {
  monthSelector,
  nextMonthAvailableSelector,
  todaySelector,
  activeDayIdsSelector,
  loadingProgressSelector
} from 'selectors'
import { startOfTheWeekSelector } from 'selectors/week'
import { isDiagnosticsEnabledSelector } from 'selectors/diagnostics'
import { daySelector, hideEventTypeDetailsSelector } from 'selectors/calendar'
import { useFeatures } from 'components/use_organization'

import Timezone from '../timezone'
import _StyledCalendar from "dates-StyledCalendar.module.css!=!astroturf/inline-loader?style=1!/app/frontend/components/select_date_time/spotpicker/dates.js?styleId=StyledCalendar";


const StyledCalendar = /*#__PURE__*/styled(Calendar, null, {
  displayName: "StyledCalendar",
  styles: _StyledCalendar,
  attrs: props => ({
    ...props,
    isPhone: useDeviceType('isPhone')
  })
})

const Dates = () => {
  const dispatch = useDispatch()
  const calendar = useSelector((state) => state.calendar)
  const today = useSelector(todaySelector)
  const activeDayIds = useSelector(activeDayIdsSelector)
  const isLoading = useSelector(loadingProgressSelector) < 100
  const diagnosticsEnabled = useSelector(isDiagnosticsEnabledSelector)
  const month = useSelector(monthSelector)
  const weekStartDay = useSelector(startOfTheWeekSelector)
  const day = useSelector(daySelector)
  const hasNoSidebar = useSelector(hideEventTypeDetailsSelector)
  const isPhone = useDeviceType('isPhone')
  const {
    availability_timezone: eventTypeTimezone,
    period_type: eventTypePeriodType,
    start_date: eventTypeStartDate
  } = useSelector(eventTypeSelector)
  const theme = parseQuery(window.location.search)

  const { data } = useFeatures()
  const hasCustomTheme = Boolean(theme.primary_color) && Boolean(!data || data.custom_theme_allowed)

  const isNextMonthAvailable = useSelector(nextMonthAvailableSelector)

  const onSelectDay = useCallback((dayToSelect, selectedSpot, isFromKeyboard) => {
    dispatch(selectCalendarDay(dayToSelect, isFromKeyboard))
    dispatch(removeSpotFromCheckQueue(selectedSpot))
  }, [dispatch])

  const onClickPrevMonth = useCallback(() => {
    dispatch(changeCalendarMonth(-1))
  }, [dispatch])

  const onClickNextMonth = useCallback(() => {
    dispatch(changeCalendarMonth(1))
  }, [dispatch])

  return (
    <Wrapper hasSelectedDay={!!day} data-component="spotpicker-dates">
      {isPhone && <Title compact={hasNoSidebar} />}
      <CalendarContainer>
        <StyledCalendar
          calendar={calendar}
          today={today}
          activeDayIds={activeDayIds}
          isLoading={isLoading}
          diagnosticsEnabled={diagnosticsEnabled}
          hasCustomTheme={hasCustomTheme}
          month={month}
          weekStartDay={weekStartDay}
          compact={isPhone && hasNoSidebar}
          eventTypeTimezone={eventTypeTimezone}
          eventTypePeriodType={eventTypePeriodType}
          eventTypeStartDate={eventTypeStartDate}
          isNextMonthAvailable={isNextMonthAvailable}
          onClickPrevMonth={onClickPrevMonth}
          onClickNextMonth={onClickNextMonth}
          onSelectDay={onSelectDay}
        />
        <Timezone />
      </CalendarContainer>
    </Wrapper>
  )
}

export default Dates
